import React, { useState, useEffect } from 'react';
import { Flex } from 'rebass';
import { Select, Label } from '@rebass/forms';
import services from 'services/services';
import { useToasts } from 'react-toast-notifications';
import helpers from 'utils/helpers';

const MERGE_TAG_STUDY_INCENTIVE = 'Study Incentive';
const MERGE_TAG_STUDY_SESSION = 'Scheduled Session';
const MERGE_TAG_STUDY_LOCATION = 'Scheduled Location';
const MERGE_TAG_PANELIST_UUID = 'PanelistUuid';
const MERGE_TAG_STUDYPANELIST_ID = 'StudyPanelistUuid';

export default function VariablesHelper() {
    const [renderCustomColumns, setRenderCustomColumns] = useState([]);
    const { addToast } = useToasts();

    useEffect(() => {
        getCustomDataColumnsXHR();
    }, []);

    function addCustomColumnMergeTag(e) {
        let mergeTag = e.target.value;
        mergeTag = `{${mergeTag}}`;

        helpers.copyToClipboard(mergeTag);

        addToast(`${mergeTag} copied to clipboard`, {
            appearance: 'success',
            autoDismiss: true
        });
    }

    function getCustomDataColumnsXHR() {
        const study_meta_tags = [
            { title: MERGE_TAG_STUDYPANELIST_ID},
            { title: MERGE_TAG_STUDY_SESSION },
            { title: MERGE_TAG_STUDY_LOCATION },
            { title: MERGE_TAG_STUDY_INCENTIVE },
        ];
        const additional_panelist_columns = [{
            title: MERGE_TAG_PANELIST_UUID
        }];
        services
            .getCustomDataColumnsXHR()
            .then(columns_xhr => {
                //console.log('GOT NEW COLUMNS', columns_xhr);
                const new_cols = [];
                new_cols.push(<option></option>);
                new_cols.push(<option disabled>- - - Panelist Properties - - -</option>);
                additional_panelist_columns.forEach(col => {
                    new_cols.push(<option key={col.title} value={col.title}>{col.title}</option>);
                });
                columns_xhr.forEach(col => {
                    new_cols.push(<option key={col.title} value={col.title}>{col.title}</option>);
                });
                new_cols.push(<option disabled>- - - Study Properties - - -</option>);
                study_meta_tags.forEach(col => {
                    new_cols.push(<option key={col.title} value={col.title}>{col.title}</option>);
                });

                setRenderCustomColumns(new_cols);
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);
                console.log(errorText);
            });
    }

    return (
        <Flex mb={2} sx={{ width: '100%', flexDirection: 'column' }}>
            <Label htmlFor="email_screener_subject">Merge Tags</Label>
            <Select
                style={{ width: '100% !important', display: 'block' }}
                onChange={e => {
                    addCustomColumnMergeTag(e);
                }}
            >
                {renderCustomColumns}
            </Select>
            {/* <Button variant="tertiary" mr={2} onClick={addScreenerLink}>
                <FiFileText /> Insert Screener Link
            </Button>
            <Button variant="tertiary" onClick={addSchedulingLink}>
                <FiCalendar /> Insert Scheduling Link
            </Button> */}
        </Flex>
    );
}
